/**
 * The two round controls docked in the bottom-right corner, right to left: the game controls helper
 * (HelpTooltip), then Leave Feedback (FeedbackDrawer). They sit apart in the tree, so their offsets
 * come from here to stay in line. SC-375 moved the helper down from the top right, where its toggle
 * covered the gallery's "Back to map" button.
 */
export const BOTTOM_RIGHT_EDGE = 24
export const BOTTOM_RIGHT_GAP = 12
/** Both toggles are the same size, so they read as one row of controls. */
export const TOGGLE_SIZE = 48

/** Feedback sits just left of the helper toggle. */
export const FEEDBACK_RIGHT = BOTTOM_RIGHT_EDGE + TOGGLE_SIZE + BOTTOM_RIGHT_GAP
